jQuery ->
  $( 'tr[data-href]' ).css( 'cursor', 'pointer' ).click ->
    window.location = $( @ ).data 'href'